import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const failures = [{
  title: "Generic '8-hour sleep' advice",
  desc: 'Ignores your specific Autonomic Nervous System state.'
}, {
  title: 'Standard melatonin supplements',
  desc: "Crush your natural drive and create a 'hangover' effect."
}, {
  title: "Focusing on quantity over the 'Thermal Dump'",
  desc: 'Ensures your core temperature never drops enough for Deep Sleep.'
}, {
  title: 'Watching your data without a plan',
  desc: "Creates 'Data Anxiety,' which actively lowers your HRV."
}];
export function WhyFailed() {
  return <section className="py-20 bg-brand-dark" data-id="element-224">
      <div className="max-w-6xl mx-auto px-6" data-id="element-225">
        <div className="text-center mb-16" data-id="element-226">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4" data-id="element-227">
            Why What You Tried Didn't Work
          </h2>
          <p className="text-brand-gray" data-id="element-228">
            The standard advice is keeping you in the red.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-229">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-panel border border-brand-panelBorder rounded-2xl p-6 flex gap-4 items-start" data-id="element-230">
              <div className="mt-1" data-id="element-231">
                <XCircle className="w-6 h-6 text-brand-red" data-id="element-232" />
              </div>
              <div data-id="element-233">
                <h3 className="text-lg font-bold mb-2" data-id="element-234">{item.title}</h3>
                <p className="text-brand-gray leading-relaxed" data-id="element-235">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}